module.exports = __webpack_public_path__ + "static/img/pigu.9e94716.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/productBanner/man/banner/pigu.jpg
// module id = EMwj
// module chunks = 0